<template>
  <v-overlay
    id="payment-services-payment-type-blocker"
    class="text-center"
    absolute
  >
    <v-row>
      <v-col cols="12">
        <v-card class="p-subs-card rounded pa-4 pa-md-6 mb-4 mb-md-6">
          <v-icon class="p-subs-icon mb-4">mdi-account-cancel-outline</v-icon>
          <p class="g-text-color-primary g-bold g-heading-s mb-3">
            ACCESS DENIED
          </p>
          <p class="g-text-color-black">{{ errorMessage }}</p>
          <br />
          <v-btn
            rounded
            class="i-btn-block-secondary p-subs-btn"
            raised
            large
            :to="{ name: 'dashboard' }"
          >
            <strong>Dashboard</strong>
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-overlay>
</template>

<script>
export default {
  props: {
    errorMessage: {
      type: String,
      required: false,
      default: 'You do not have access to this page'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

#payment-services-payment-type-blocker {
  .p-subs-btn {
    background-color: $secondary-color;
    color: white;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.75px;
    text-transform: none;
    width: 200px;
  }

  .p-subs-card {
    background-color: white;
    width: 90%;
    max-width: 360px;
    margin: auto;
  }

  .p-subs-icon {
    color: $secondary-color;

    &:before {
      font-size: 32px;
    }
  }
}

@media only screen and (min-width: 960px) {
  #payment-services-payment-type-blocker {
    .p-subs-btn {
      font-size: 16px;
      width: 250px;
    }

    .p-subs-card {
      min-width: 450px;
    }

    .p-subs-icon:before {
      font-size: 64px;
    }
  }
}
</style>
